import React from 'react';
import './GroupLogin.css';
import logoba from '../../../../assets/img/logo-ba.png';
import FacebookLogin from 'react-facebook-login';

let GroupLogin = props => {
    return (
        <div className="group-login">
            <img src={logoba} alt="logo black and white"/>
            <p>Login with <b>Facebook</b> to enter the competition</p>
            <FacebookLogin
                appId="158573034958328"
                fields="name,email,picture"
                onClick={props.getLogin.loading}
                callback={props.getLogin.set} />
        </div>
    );
};

export default GroupLogin;


// WEBPACK FOOTER //
// ./src/components/Groups/Group/GroupLogin/GroupLogin.jsx